import LocalDate from '@booking-services/localDate'

const applicableSupplementSelector = ({bookingDate = new LocalDate(), supplementAdjustments, roomType}) => {
  const supplementAdjustment = supplementAdjustments
    .find(adjustment => adjustment.roomType === roomType
        && adjustment.startDate <= bookingDate
        && (adjustment.endDate === null || adjustment.endDate >= bookingDate))
  return {
    commissionReduction: supplementAdjustment && supplementAdjustment.taCommission || false,
    discountReduction: supplementAdjustment && supplementAdjustment.discountPromo || false,
    ftdApplicable: supplementAdjustment && supplementAdjustment.ftd || false,
  }
}

const isApplicableSupplementEnabled = ({rooms = [], supplementAdjustments}) => {
  const supplements = rooms.map(({roomType}) => applicableSupplementSelector({supplementAdjustments, roomType}))
  return {
    commissionReduction: supplements.find(({commissionReduction}) => commissionReduction) || false,
    discountReduction: supplements.find(({discountReduction}) => discountReduction) || false,
    ftdApplicable: supplements.find(({ftdApplicable}) => ftdApplicable) || false,
  }
}

export {
  applicableSupplementSelector,
  isApplicableSupplementEnabled
}